module.exports = __webpack_public_path__ + "static/media/Fantasy_7_t.b648f57d.jpg";